import src from "IMAGE";
export default { src, width: 217, height: 62, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGANEFJ3EBRjTQoNRkEJCzliDxJLVw4RRTQKCyg0CQsmABICAywZAwQ6GAMEMx4GBzNcQEJGdl5fQnBcXUFwYGA5Y7AMJ5j7f0sAAAAASUVORK5CYII="};
